<template>
  <!-- <summary-count title="Active Prescriptions" :is-loading="isLoading" :count="activePrescriptions" :change-count="changeCount" :tooltip="tooltipText" @cardClicked="gotoLink()" /> -->
  <summary-count title="Active Prescriptions" :is-loading="isLoading" :count="activePrescriptions" :change-count="changeCount" @cardClicked="gotoLink()" />
</template>

<script>
import SummaryCount from "@/views/business/dashboard/components/SummaryCount.vue";
import moment from "moment";
import { mapGetters } from "vuex";

export default {
  name: "ActivePrescriptions",
  components: {
    SummaryCount,
  },
  props: {
    businessId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      activePrescriptions: 0,
      changeCount: 0,
      isLoading: false,
    };
  },
  computed: {
    ...mapGetters("role", ["isLocationFiltered"]),
    startOfWeek() {
      return moment()
        .startOf("week")
        .toDate();
    },
    endOfWeek() {
      return moment()
        .endOf("week")
        .toDate();
    },
    tooltipText() {
      return `This represents how many active Prescriptions are present on your Patient’s profiles. Some of these patients may not have active plans, meaning they have yet to begin or may have a requested delay in starting.`;
    },
  },
  created() {
    this.loadPrescriptions();
  },
  methods: {
    loadPrescriptions() {
      this.isLoading = true;

      let url = `/businesses/${this.businessId}/dashboard/activeprescriptions`;

      this.$axios
        .get(url, {
          params: {
            startOfWeek: this.startOfWeek,
            endOfWeek: this.endOfWeek,
          },
        })
        .then((res) => {
          this.activePrescriptions = res.data.activePrescriptions;
          this.changeCount = this.isLocationFiltered == false ? res.data.changeCount : 0;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    gotoLink() {
      this.$router.push(`/businesses/${this.businessId}/prescriptions`);
    },
  },
};
</script>
